import React, {
    PureComponent,
} from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import horseUrlBuilder from '../GriddleRP/urlBuilder';
import Svg from 'rp-react-svg-icon';

import {
    mapCurrencyCodeToSymbol,
    mapCountryCodeToCountry,
} from '../../utils/dataHelper';

class CarouselItem extends PureComponent {
    render() {
        const { item, isCarouselDragging } = this.props;
        const carouselLink = horseUrlBuilder(item.horseUid, item.styleName);

        return (
            <div className={'carousel-item'}>
                <a className="carousel-item__img-wrapper">
                    <img
                        className="carousel-item__img"
                        src={item.stallionImage} alt=""
                        onClick={(e) => {
                            if (isCarouselDragging) {
                                e.preventDefault();
                                return;
                            }
                            const windowWidth = window.innerWidth;

                            if (windowWidth >= 990) {
                                window.open(carouselLink, 'popUpWindow', 'width=750,height=800');
                            } else if (windowWidth < 990 && windowWidth >= 720) {
                                window.open(carouselLink, '_blank');
                            } else {
                                window.open(carouselLink, '_self');
                            }
                        }}
                    />
                </a>

                <div className="carousel-item_info">
                    <div className="carousel-item_info-title">
                        <span className="carousel-item_info-title-text">
                            {item.styleName} ({item.countryOriginCode})
                        </span>
                        <span className="carousel-item_info-title-fee-box">
                            {mapCurrencyCodeToSymbol(item.feeCurCode)} {numeral(item.studFee).format('0,0')}
                        </span>
                    </div>

                    <span className="carousel-item_info-stud">
                        <Svg iconName={'pin'} size={'Small'} />
                        {item.studName}, {mapCountryCodeToCountry(item.studCountryCode)}
                    </span>
                </div>
            </div>
        );
    }
}

CarouselItem.propTypes = {
    isCarouselDragging: PropTypes.bool,
    item: {
        horseUid: PropTypes.number,
        styleName: PropTypes.string,
        countryOriginCode: PropTypes.string,
        studFee: PropTypes.number,
        studFeeCondition: PropTypes.string,
        studName: PropTypes.string,
        studCountryCode: PropTypes.string,
        feeCurCode: PropTypes.string,
        stallionImage: PropTypes.string,
    }
};

export default CarouselItem;



// WEBPACK FOOTER //
// ./src/client/components/Carousel/CarouselItem.js